module.exports = __webpack_public_path__ + "img/05i-Buy_Callidus01.850ced62.jpg";